import { z } from 'zod';

// Mirrors legacy `form/HotelSearchForm/schema.ts`. Plain useState +
// safeParse pattern (no react-hook-form in the new monorepo).
export const hotelSearchSchema = z.object({
  checkIn: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  nights: z.number().int().min(1),
  guests: z.number().int().min(1),
  // HyperGuest's own numeric hotel ids (stringified), not our product UUIDs.
  hotelIds: z.array(z.string().min(1)).min(1),
});

export type HotelSearchValues = z.infer<typeof hotelSearchSchema>;
